/**
 * Textos das telas "Fornecedores" e "Ordem de entrega" (submenus de Compras) e
 * do toggle "Estoque local" da Nova Entrada de Estoque. Segue o formato de
 * `textosEtapas.ts` — o orquestrador registra este dicionário em
 * `i18n/IdiomaProvider.tsx`.
 */
export const TEXTOS_COMPRAS_FORNECEDORES = {
  pt: {
    "Ordem de entrega": "Ordem de entrega",
    "Pedidos de suprimento enviados a outras empresas, pendentes ou aprovados.":
      "Pedidos de suprimento enviados a outras empresas, pendentes ou aprovados.",
    "Pedidos aprovados com os dados de entrega para a empresa de destino.":
      "Pedidos aprovados com os dados de entrega para a empresa de destino.",
    Aprovados: "Aprovados",
    "Empresa fornecedora": "Empresa fornecedora",
    "Venda de origem": "Venda de origem",
    "Galpão de origem": "Galpão de origem",
    "Aprovado por": "Aprovado por",
    "Dados de envio": "Dados de envio",
    "Dados de envio ou retirada": "Dados de envio ou retirada",
    "Liberação e envio": "Liberação e envio",
    "Aprovar pedido de suprimento": "Aprovar pedido de suprimento",
    "Aprovar pedido": "Aprovar pedido",
    "Confirmar aprovação": "Confirmar aprovação",
    "Nenhum pedido de fornecedor": "Nenhum pedido de fornecedor",
    "Pedidos gerados por vendas com estoque de outra empresa aparecerão aqui.":
      "Pedidos gerados por vendas com estoque de outra empresa aparecerão aqui.",
    "Nenhuma ordem de entrega": "Nenhuma ordem de entrega",
    "Pedidos de suprimento aprovados aparecerão aqui com os dados de entrega.":
      "Pedidos de suprimento aprovados aparecerão aqui com os dados de entrega.",
    "Dados da entrega": "Dados da entrega",
    "Estoque local": "Estoque local",
    "Marca esta entrada como pertencente de fato à empresa selecionada acima.":
      "Marca esta entrada como pertencente de fato à empresa selecionada acima.",
    "Pedidos de suprimento abertos por vendas que usam estoque de outra empresa, até a aprovação.":
      "Pedidos de suprimento abertos por vendas que usam estoque de outra empresa, até a aprovação.",
    "Pedidos de suprimento já aprovados, com os dados de entrega para a empresa de destino.":
      "Pedidos de suprimento já aprovados, com os dados de entrega para a empresa de destino.",
    "Buscar por numero, empresa, venda...": "Buscar por numero, empresa, venda...",
    "Dashboard do Fornecedor": "Dashboard do Fornecedor",
    "Visão exclusiva das vendas recebidas como pedidos de compra pelo fornecedor.": "Visão exclusiva das vendas recebidas como pedidos de compra pelo fornecedor.",
    "Relatório de Revenda": "Relatório de Revenda",
    "Resumo dos pedidos recebidos pelo fornecedor.": "Resumo dos pedidos recebidos pelo fornecedor.",
    "Pedidos de compra originados pelas vendas.": "Pedidos de compra originados pelas vendas.",
    "Pedidos expedidos com nota fiscal e destino.": "Pedidos expedidos com nota fiscal e destino.",
    "Relatórios dos pedidos atendidos pelo fornecedor.": "Relatórios dos pedidos atendidos pelo fornecedor.",
    "Gerencie acessos do módulo do fornecedor.": "Gerencie acessos do módulo do fornecedor.",
    "Este local está marcado como Estoque do fornecedor.": "Este local está marcado como Estoque do fornecedor.",
    "A venda será enviada ao menu Fornecedor como pedido de compra.": "A venda será enviada ao menu Fornecedor como pedido de compra.",
    "A pré-venda só será enviada ao fornecedor quando for finalizada.": "A pré-venda só será enviada ao fornecedor quando for finalizada.",
    "Este é um estoque da empresa. A venda será processada localmente e não será enviada ao fornecedor.": "Este é um estoque da empresa. A venda será processada localmente e não será enviada ao fornecedor.",
    "Pedido para o fornecedor": "Pedido para o fornecedor",
    "Produto solicitado ao fornecedor": "Produto solicitado ao fornecedor",
    "geram um pedido no menu Fornecedor porque o local escolhido está marcado como Estoque do fornecedor.": "geram um pedido no menu Fornecedor porque o local escolhido está marcado como Estoque do fornecedor.",
    "Pedido enviado e aguardando expedição pelo fornecedor.": "Pedido enviado e aguardando expedição pelo fornecedor.",
    "Ao salvar, a venda fica pendente aguardando a expedição do fornecedor.": "Ao salvar, a venda fica pendente aguardando a expedição do fornecedor.",
    "Ao expedir o pedido no menu Fornecedor, o produto sai do estoque selecionado, a venda é processada e a entrega recebe a nota fiscal, a data de saída e o destino.": "Ao expedir o pedido no menu Fornecedor, o produto sai do estoque selecionado, a venda é processada e a entrega recebe a nota fiscal, a data de saída e o destino.",
    Expedidos: "Expedidos",
    "Data de saída": "Data de saída",
    Destino: "Destino",
    "Expedido por": "Expedido por",
    "Nota fiscal": "Nota fiscal",
    "Pedidos de compra do fornecedor": "Pedidos de compra do fornecedor",
    "Vendas enviadas ao fornecedor porque o local escolhido está marcado como Estoque do fornecedor.": "Vendas enviadas ao fornecedor porque o local escolhido está marcado como Estoque do fornecedor.",
    "Nenhum pedido recebido": "Nenhum pedido recebido",
    "As vendas vinculadas a um Estoque do fornecedor aparecerão aqui.": "As vendas vinculadas a um Estoque do fornecedor aparecerão aqui.",
    "Expedir pedido": "Expedir pedido",
    Expedir: "Expedir",
    "Informe a nota fiscal e os dados de saída da venda": "Informe a nota fiscal e os dados de saída da venda",
    "Cliente e entrega": "Cliente e entrega",
    "Produtos do pedido": "Produtos do pedido",
    Expedição: "Expedição",
    "Informe a data de saída.": "Informe a data de saída.",
    "Informe o destino da entrega.": "Informe o destino da entrega.",
    "Anexe a nota fiscal antes de expedir o pedido.": "Anexe a nota fiscal antes de expedir o pedido.",
    "Entregas do fornecedor": "Entregas do fornecedor",
    "Pedidos expedidos com data de saída, destino e nota fiscal anexada.": "Pedidos expedidos com data de saída, destino e nota fiscal anexada.",
    "Nenhuma entrega expedida": "Nenhuma entrega expedida",
    "Os pedidos enviados pela ação Expedir aparecerão aqui.": "Os pedidos enviados pela ação Expedir aparecerão aqui.",
    "Dados da entrega do fornecedor": "Dados da entrega do fornecedor",
    "Produtos dos Pedidos": "Produtos dos Pedidos",
    "Pedidos por Período": "Pedidos por Período",
    "Expedições Pendentes": "Expedições Pendentes",
    "Histórico de Pedidos": "Histórico de Pedidos",
    "Produtos e valores": "Produtos e valores",
    Expedido: "Expedido",
    "Não foi possível expedir o pedido.": "Não foi possível expedir o pedido.",
    "Pedido expedido. A venda": "Pedido expedido. A venda",
    vinculada: "vinculada",
    "foi liberada e lançada no financeiro.": "foi liberada e lançada no financeiro.",
    "Pedido expedido. A venda continua aguardando os demais pedidos do fornecedor.": "Pedido expedido. A venda continua aguardando os demais pedidos do fornecedor.",
  },
  en: {
    "Ordem de entrega": "Delivery Order",
    "Pedidos de suprimento enviados a outras empresas, pendentes ou aprovados.":
      "Supply orders sent to other companies, pending or approved.",
    "Pedidos aprovados com os dados de entrega para a empresa de destino.":
      "Approved orders with delivery details for the destination company.",
    Aprovados: "Approved",
    "Empresa fornecedora": "Supplying company",
    "Venda de origem": "Source sale",
    "Galpão de origem": "Source warehouse",
    "Aprovado por": "Approved by",
    "Dados de envio": "Shipping details",
    "Dados de envio ou retirada": "Shipping or pickup details",
    "Liberação e envio": "Release and shipping",
    "Aprovar pedido de suprimento": "Approve supply order",
    "Aprovar pedido": "Approve order",
    "Confirmar aprovação": "Confirm approval",
    "Nenhum pedido de fornecedor": "No supplier orders",
    "Pedidos gerados por vendas com estoque de outra empresa aparecerão aqui.":
      "Orders generated by sales using another company's stock will appear here.",
    "Nenhuma ordem de entrega": "No delivery orders",
    "Pedidos de suprimento aprovados aparecerão aqui com os dados de entrega.":
      "Approved supply orders will appear here with the delivery details.",
    "Dados da entrega": "Delivery details",
    "Estoque local": "Local stock",
    "Marca esta entrada como pertencente de fato à empresa selecionada acima.":
      "Marks this entry as actually belonging to the company selected above.",
    "Pedidos de suprimento abertos por vendas que usam estoque de outra empresa, até a aprovação.":
      "Supply orders opened by sales that use another company's stock, until approval.",
    "Pedidos de suprimento já aprovados, com os dados de entrega para a empresa de destino.":
      "Supply orders already approved, with delivery details for the destination company.",
    "Buscar por numero, empresa, venda...": "Search by number, company, sale...",
    "Dashboard do Fornecedor": "Supplier Dashboard",
    "Visão exclusiva das vendas recebidas como pedidos de compra pelo fornecedor.": "Exclusive view of sales received by the supplier as purchase orders.",
    "Relatório de Revenda": "Reseller Report",
    "Resumo dos pedidos recebidos pelo fornecedor.": "Summary of orders received by the supplier.",
    "Pedidos de compra originados pelas vendas.": "Purchase orders generated from sales.",
    "Pedidos expedidos com nota fiscal e destino.": "Shipped orders with invoice and destination.",
    "Relatórios dos pedidos atendidos pelo fornecedor.": "Reports for orders fulfilled by the supplier.",
    "Gerencie acessos do módulo do fornecedor.": "Manage access to the supplier module.",
    "Este local está marcado como Estoque do fornecedor.": "This location is marked as Supplier inventory.",
    "A venda será enviada ao menu Fornecedor como pedido de compra.": "The sale will be sent to the Supplier menu as a purchase order.",
    "A pré-venda só será enviada ao fornecedor quando for finalizada.": "The pre-sale will only be sent to the supplier when it is finalized.",
    "Este é um estoque da empresa. A venda será processada localmente e não será enviada ao fornecedor.": "This is company inventory. The sale will be processed locally and will not be sent to the supplier.",
    "Pedido para o fornecedor": "Order for the supplier",
    "Produto solicitado ao fornecedor": "Product requested from the supplier",
    "geram um pedido no menu Fornecedor porque o local escolhido está marcado como Estoque do fornecedor.": "generate an order in the Supplier menu because the selected location is marked as Supplier inventory.",
    "Pedido enviado e aguardando expedição pelo fornecedor.": "Order sent and awaiting shipment by the supplier.",
    "Ao salvar, a venda fica pendente aguardando a expedição do fornecedor.": "When saved, the sale remains pending until the supplier ships it.",
    "Ao expedir o pedido no menu Fornecedor, o produto sai do estoque selecionado, a venda é processada e a entrega recebe a nota fiscal, a data de saída e o destino.": "When the order is shipped in the Supplier menu, the product leaves the selected inventory, the sale is processed, and the delivery receives the invoice, departure date, and destination.",
    Expedidos: "Shipped",
    "Data de saída": "Departure date",
    Destino: "Destination",
    "Expedido por": "Shipped by",
    "Nota fiscal": "Invoice",
    "Pedidos de compra do fornecedor": "Supplier purchase orders",
    "Vendas enviadas ao fornecedor porque o local escolhido está marcado como Estoque do fornecedor.": "Sales sent to the supplier because the selected location is marked as Supplier inventory.",
    "Nenhum pedido recebido": "No orders received",
    "As vendas vinculadas a um Estoque do fornecedor aparecerão aqui.": "Sales linked to Supplier inventory will appear here.",
    "Expedir pedido": "Ship order",
    Expedir: "Ship",
    "Informe a nota fiscal e os dados de saída da venda": "Enter the invoice and shipping details for sale",
    "Cliente e entrega": "Customer and delivery",
    "Produtos do pedido": "Order products",
    Expedição: "Shipment",
    "Informe a data de saída.": "Enter the departure date.",
    "Informe o destino da entrega.": "Enter the delivery destination.",
    "Anexe a nota fiscal antes de expedir o pedido.": "Attach the invoice before shipping the order.",
    "Entregas do fornecedor": "Supplier deliveries",
    "Pedidos expedidos com data de saída, destino e nota fiscal anexada.": "Orders shipped with departure date, destination, and attached invoice.",
    "Nenhuma entrega expedida": "No shipped deliveries",
    "Os pedidos enviados pela ação Expedir aparecerão aqui.": "Orders sent with the Ship action will appear here.",
    "Dados da entrega do fornecedor": "Supplier delivery details",
    "Produtos dos Pedidos": "Order Products",
    "Pedidos por Período": "Orders by Period",
    "Expedições Pendentes": "Pending Shipments",
    "Histórico de Pedidos": "Order History",
    "Produtos e valores": "Products and values",
    Expedido: "Shipped",
    "Não foi possível expedir o pedido.": "The order could not be shipped.",
    "Pedido expedido. A venda": "Order shipped. Sale",
    vinculada: "linked",
    "foi liberada e lançada no financeiro.": "was released and posted to finance.",
    "Pedido expedido. A venda continua aguardando os demais pedidos do fornecedor.": "Order shipped. The sale is still awaiting the other supplier orders.",
  },
  es: {
    "Ordem de entrega": "Orden de entrega",
    "Pedidos de suprimento enviados a outras empresas, pendentes ou aprovados.":
      "Pedidos de suministro enviados a otras empresas, pendientes o aprobados.",
    "Pedidos aprovados com os dados de entrega para a empresa de destino.":
      "Pedidos aprobados con los datos de entrega para la empresa de destino.",
    Aprovados: "Aprobados",
    "Empresa fornecedora": "Empresa proveedora",
    "Venda de origem": "Venta de origen",
    "Galpão de origem": "Almacén de origen",
    "Aprovado por": "Aprobado por",
    "Dados de envio": "Datos de envío",
    "Dados de envio ou retirada": "Datos de envío o retiro",
    "Liberação e envio": "Liberación y envío",
    "Aprovar pedido de suprimento": "Aprobar pedido de suministro",
    "Aprovar pedido": "Aprobar pedido",
    "Confirmar aprovação": "Confirmar aprobación",
    "Nenhum pedido de fornecedor": "Ningún pedido de proveedor",
    "Pedidos gerados por vendas com estoque de outra empresa aparecerão aqui.":
      "Los pedidos generados por ventas que usan stock de otra empresa aparecerán aquí.",
    "Nenhuma ordem de entrega": "Ninguna orden de entrega",
    "Pedidos de suprimento aprovados aparecerão aqui com os dados de entrega.":
      "Los pedidos de suministro aprobados aparecerán aquí con los datos de entrega.",
    "Dados da entrega": "Datos de la entrega",
    "Estoque local": "Stock local",
    "Marca esta entrada como pertencente de fato à empresa selecionada acima.":
      "Marca esta entrada como perteneciente de hecho a la empresa seleccionada arriba.",
    "Pedidos de suprimento abertos por vendas que usam estoque de outra empresa, até a aprovação.":
      "Pedidos de suministro abiertos por ventas que usan stock de otra empresa, hasta la aprobación.",
    "Pedidos de suprimento já aprovados, com os dados de entrega para a empresa de destino.":
      "Pedidos de suministro ya aprobados, con los datos de entrega para la empresa de destino.",
    "Buscar por numero, empresa, venda...": "Buscar por número, empresa, venta...",
    "Dashboard do Fornecedor": "Panel del Proveedor",
    "Visão exclusiva das vendas recebidas como pedidos de compra pelo fornecedor.": "Vista exclusiva de las ventas recibidas por el proveedor como pedidos de compra.",
    "Relatório de Revenda": "Informe de Reventa",
    "Resumo dos pedidos recebidos pelo fornecedor.": "Resumen de los pedidos recibidos por el proveedor.",
    "Pedidos de compra originados pelas vendas.": "Pedidos de compra originados por las ventas.",
    "Pedidos expedidos com nota fiscal e destino.": "Pedidos despachados con factura y destino.",
    "Relatórios dos pedidos atendidos pelo fornecedor.": "Informes de los pedidos atendidos por el proveedor.",
    "Gerencie acessos do módulo do fornecedor.": "Gestione los accesos al módulo del proveedor.",
    "Este local está marcado como Estoque do fornecedor.": "Esta ubicación está marcada como Inventario del proveedor.",
    "A venda será enviada ao menu Fornecedor como pedido de compra.": "La venta se enviará al menú Proveedor como pedido de compra.",
    "A pré-venda só será enviada ao fornecedor quando for finalizada.": "La preventa solo se enviará al proveedor cuando se finalice.",
    "Este é um estoque da empresa. A venda será processada localmente e não será enviada ao fornecedor.": "Este es un inventario de la empresa. La venta se procesará localmente y no se enviará al proveedor.",
    "Pedido para o fornecedor": "Pedido para el proveedor",
    "Produto solicitado ao fornecedor": "Producto solicitado al proveedor",
    "geram um pedido no menu Fornecedor porque o local escolhido está marcado como Estoque do fornecedor.": "generan un pedido en el menú Proveedor porque la ubicación elegida está marcada como Inventario del proveedor.",
    "Pedido enviado e aguardando expedição pelo fornecedor.": "Pedido enviado y pendiente de despacho por el proveedor.",
    "Ao salvar, a venda fica pendente aguardando a expedição do fornecedor.": "Al guardar, la venta queda pendiente a la espera del despacho del proveedor.",
    "Ao expedir o pedido no menu Fornecedor, o produto sai do estoque selecionado, a venda é processada e a entrega recebe a nota fiscal, a data de saída e o destino.": "Al despachar el pedido en el menú Proveedor, el producto sale del inventario seleccionado, la venta se procesa y la entrega recibe la factura, la fecha de salida y el destino.",
    Expedidos: "Despachados",
    "Data de saída": "Fecha de salida",
    Destino: "Destino",
    "Expedido por": "Despachado por",
    "Nota fiscal": "Factura",
    "Pedidos de compra do fornecedor": "Pedidos de compra del proveedor",
    "Vendas enviadas ao fornecedor porque o local escolhido está marcado como Estoque do fornecedor.": "Ventas enviadas al proveedor porque la ubicación elegida está marcada como Inventario del proveedor.",
    "Nenhum pedido recebido": "Ningún pedido recibido",
    "As vendas vinculadas a um Estoque do fornecedor aparecerão aqui.": "Las ventas vinculadas a un Inventario del proveedor aparecerán aquí.",
    "Expedir pedido": "Despachar pedido",
    Expedir: "Despachar",
    "Informe a nota fiscal e os dados de saída da venda": "Informe la factura y los datos de salida de la venta",
    "Cliente e entrega": "Cliente y entrega",
    "Produtos do pedido": "Productos del pedido",
    Expedição: "Despacho",
    "Informe a data de saída.": "Informe la fecha de salida.",
    "Informe o destino da entrega.": "Informe el destino de la entrega.",
    "Anexe a nota fiscal antes de expedir o pedido.": "Adjunte la factura antes de despachar el pedido.",
    "Entregas do fornecedor": "Entregas del proveedor",
    "Pedidos expedidos com data de saída, destino e nota fiscal anexada.": "Pedidos despachados con fecha de salida, destino y factura adjunta.",
    "Nenhuma entrega expedida": "Ninguna entrega despachada",
    "Os pedidos enviados pela ação Expedir aparecerão aqui.": "Los pedidos enviados con la acción Despachar aparecerán aquí.",
    "Dados da entrega do fornecedor": "Datos de entrega del proveedor",
    "Produtos dos Pedidos": "Productos de los Pedidos",
    "Pedidos por Período": "Pedidos por Período",
    "Expedições Pendentes": "Despachos Pendientes",
    "Histórico de Pedidos": "Historial de Pedidos",
    "Produtos e valores": "Productos y valores",
    Expedido: "Despachado",
    "Não foi possível expedir o pedido.": "No fue posible despachar el pedido.",
    "Pedido expedido. A venda": "Pedido despachado. La venta",
    vinculada: "vinculada",
    "foi liberada e lançada no financeiro.": "fue liberada y registrada en finanzas.",
    "Pedido expedido. A venda continua aguardando os demais pedidos do fornecedor.": "Pedido despachado. La venta continúa esperando los demás pedidos del proveedor.",
  },
  "zh-CN": {
    "Ordem de entrega": "交货单",
    "Pedidos de suprimento enviados a outras empresas, pendentes ou aprovados.":
      "发送给其他公司的补货订单，待批准或已批准。",
    "Pedidos aprovados com os dados de entrega para a empresa de destino.":
      "已批准的订单，包含目的公司的发货信息。",
    Aprovados: "已批准",
    "Empresa fornecedora": "供货公司",
    "Venda de origem": "来源销售",
    "Galpão de origem": "来源仓库",
    "Aprovado por": "批准人",
    "Dados de envio": "发货信息",
    "Dados de envio ou retirada": "发货或提货信息",
    "Liberação e envio": "放行与发货",
    "Aprovar pedido de suprimento": "批准补货订单",
    "Aprovar pedido": "批准订单",
    "Confirmar aprovação": "确认批准",
    "Nenhum pedido de fornecedor": "没有供应商订单",
    "Pedidos gerados por vendas com estoque de outra empresa aparecerão aqui.":
      "使用其他公司库存的销售生成的订单将显示在此处。",
    "Nenhuma ordem de entrega": "没有交货单",
    "Pedidos de suprimento aprovados aparecerão aqui com os dados de entrega.":
      "已批准的补货订单及其发货信息将显示在此处。",
    "Dados da entrega": "交货信息",
    "Estoque local": "本地库存",
    "Marca esta entrada como pertencente de fato à empresa selecionada acima.":
      "将此入库标记为实际归属于上方选择的公司。",
    "Pedidos de suprimento abertos por vendas que usam estoque de outra empresa, até a aprovação.":
      "由使用其他公司库存的销售生成的补货订单，直至批准前。",
    "Pedidos de suprimento já aprovados, com os dados de entrega para a empresa de destino.":
      "已批准的补货订单，包含目的公司的发货信息。",
    "Buscar por numero, empresa, venda...": "按编号、公司、销售搜索...",
    "Dashboard do Fornecedor": "供应商仪表板",
    "Visão exclusiva das vendas recebidas como pedidos de compra pelo fornecedor.": "仅显示供应商以采购订单形式收到的销售。",
    "Relatório de Revenda": "经销商报表",
    "Resumo dos pedidos recebidos pelo fornecedor.": "供应商收到的订单摘要。",
    "Pedidos de compra originados pelas vendas.": "由销售生成的采购订单。",
    "Pedidos expedidos com nota fiscal e destino.": "包含发票和目的地的已发货订单。",
    "Relatórios dos pedidos atendidos pelo fornecedor.": "供应商已处理订单的报表。",
    "Gerencie acessos do módulo do fornecedor.": "管理供应商模块的访问权限。",
    "Este local está marcado como Estoque do fornecedor.": "此地点已标记为供应商库存。",
    "A venda será enviada ao menu Fornecedor como pedido de compra.": "该销售将作为采购订单发送到供应商菜单。",
    "A pré-venda só será enviada ao fornecedor quando for finalizada.": "预售仅在完成后发送给供应商。",
    "Este é um estoque da empresa. A venda será processada localmente e não será enviada ao fornecedor.": "这是公司库存。销售将在本地处理，不会发送给供应商。",
    "Pedido para o fornecedor": "供应商订单",
    "Produto solicitado ao fornecedor": "向供应商申请的产品",
    "geram um pedido no menu Fornecedor porque o local escolhido está marcado como Estoque do fornecedor.": "会在供应商菜单中生成订单，因为所选地点已标记为供应商库存。",
    "Pedido enviado e aguardando expedição pelo fornecedor.": "订单已发送，等待供应商发货。",
    "Ao salvar, a venda fica pendente aguardando a expedição do fornecedor.": "保存后，销售将保持待处理，直到供应商发货。",
    "Ao expedir o pedido no menu Fornecedor, o produto sai do estoque selecionado, a venda é processada e a entrega recebe a nota fiscal, a data de saída e o destino.": "在供应商菜单中发货后，产品从所选库存出库，销售完成处理，交付记录会保存发票、出库日期和目的地。",
    Expedidos: "已发货",
    "Data de saída": "出库日期",
    Destino: "目的地",
    "Expedido por": "发货人",
    "Nota fiscal": "发票",
    "Pedidos de compra do fornecedor": "供应商采购订单",
    "Vendas enviadas ao fornecedor porque o local escolhido está marcado como Estoque do fornecedor.": "因所选地点标记为供应商库存而发送给供应商的销售。",
    "Nenhum pedido recebido": "未收到订单",
    "As vendas vinculadas a um Estoque do fornecedor aparecerão aqui.": "关联供应商库存的销售将显示在此处。",
    "Expedir pedido": "发货",
    Expedir: "发货",
    "Informe a nota fiscal e os dados de saída da venda": "填写销售的发票和出库信息",
    "Cliente e entrega": "客户与交付",
    "Produtos do pedido": "订单产品",
    Expedição: "发货",
    "Informe a data de saída.": "请输入出库日期。",
    "Informe o destino da entrega.": "请输入交付目的地。",
    "Anexe a nota fiscal antes de expedir o pedido.": "发货前请附上发票。",
    "Entregas do fornecedor": "供应商交付",
    "Pedidos expedidos com data de saída, destino e nota fiscal anexada.": "包含出库日期、目的地和发票附件的已发货订单。",
    "Nenhuma entrega expedida": "暂无已发货交付",
    "Os pedidos enviados pela ação Expedir aparecerão aqui.": "通过“发货”操作发送的订单将显示在此处。",
    "Dados da entrega do fornecedor": "供应商交付信息",
    "Produtos dos Pedidos": "订单产品",
    "Pedidos por Período": "按期间订单",
    "Expedições Pendentes": "待发货",
    "Histórico de Pedidos": "订单历史",
    "Produtos e valores": "产品与金额",
    Expedido: "已发货",
    "Não foi possível expedir o pedido.": "无法发货。",
    "Pedido expedido. A venda": "订单已发货。销售",
    vinculada: "已关联",
    "foi liberada e lançada no financeiro.": "已放行并计入财务。",
    "Pedido expedido. A venda continua aguardando os demais pedidos do fornecedor.": "订单已发货。销售仍在等待其他供应商订单。",
  },
} as const;
